var arrMax = require('../array/max');
var values = require('./values');

    /**
     * Returns maximum value inside object.
     */
    function max(obj, compareFn) {
        return arrMax(values(obj), compareFn);
    }

    module.exports = max;




//////////////////
// WEBPACK FOOTER
// ./~/mout/object/max.js
// module id = 714
// module chunks = 0 1 2